import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  const version = "v1.0.0"

  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>
              {new Date().getFullYear()} © Dental OPD. {version}
            </Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                Develop by Catchysystems Technologies Pvt. Ltd.
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
